module.exports = __webpack_public_path__ + "static/media/google_word.f74e42d0.svg";